import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M11 8v8h2a4 4 0 1 0 0 -8h-2z","key":"svg-1"}],["path",{"d":"M8 8v8","key":"svg-2"}]]

const IconBrandPushbullet = createReactComponent('outline', 'brand-pushbullet', 'BrandPushbullet', __iconNode);

export default IconBrandPushbullet;